import AOS from "aos";
import Headroom from "headroom.js";
import Glide from "@glidejs/glide";
import Player from "@vimeo/player";
import anime from "animejs";

import Vue from "vue";
import GoogleMap from "./js/components/GoogleMap.vue";
import GooglePlaces from "./js/components/GooglePlaces.vue";
import leasingForm from "./js/components/leasingForm.vue";
import simpleMap from "./js/components/simpleMap.vue";
import TabList from "./js/components/TabList.vue";
import TabbedMenu from "./js/components/TabbedMenu.vue";

import Swup from "swup";
import SwupScriptsPlugin from "@swup/scripts-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
import SwupHeadPlugin from "@swup/head-plugin";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupJsPlugin from "@swup/js-plugin";
import SwupOverlayTheme from "@swup/overlay-theme";
// import SwupStackTheme from 'swup-stack-theme';
import SwupScrollPlugin from "@swup/scroll-plugin";

let overlay = document.querySelector(".overlay");

const swup = new Swup({
  plugins: [
    new SwupHeadPlugin(),
    new SwupScriptsPlugin({
      head: true,
      body: true,
    }),
    new SwupBodyClassPlugin(),
    // new SwupStackTheme(),
    new SwupOverlayTheme({
      color: "#2D2E82",
      duration: 600,
      direction: "to-bottom",
    }),
    new SwupScrollPlugin({
      doScrollingRightAway: true,
      animateScroll: false,
      scrollFriction: 0.3,
      scrollAcceleration: 0.04,
    }),
  ],
  cache: false,
});

init();

var googleMap,
  places,
  form,
  simpleGoogleMap,
  stacking,
  stackingImage,
  directions,
  pt,
  buildingMenu;

function init() {
  AOS.init();

  // Carousel
  if (document.querySelector(".glide-sidebar")) {
    let master = new Glide(".glide-sidebar", {
      gap: 20,
      perView: 1,
      peek: { before: 0, after: 60 },
      type: "carousel",
      autoplay: 3000,
      hoverpause: false,
      startAt: 1,
    });

    let slave = new Glide(".glide-main", {
      perView: 1,
      type: "carousel",
      autoplay: 3000,
      hoverpause: false,
    });

    if (window.innerWidth > 768) {
      master.on("run", function(e) {
        slave.go(e.direction);
      });
    }

    master.mount();
    slave.mount();
  }

  // Neighborhood - TabList
  if (document.querySelector("#neighborhood .google-map")) {
    swup.on("willReplaceContent", () => {
      googleMap.$destroy();
      places.$destroy();
    });

    googleMap = new Vue({
      name: "google-map",
      el: "#neighborhood .google-map",
      template: `<google-map :modal="openModal"  @markerClicked="markerClicked($event)" />`,
      components: {
        GoogleMap,
      },
      data() {
        return {
          openModal: null,
        };
      },
      methods: {
        markerClicked(id) {
          this.openModal = id;
          places.openModal = id;
        },
      },
    });

    places = new Vue({
      name: "places",
      el: "#neighborhood .google-places",
      template: `<GooglePlaces :modal="openModal" @placeClicked="setActiveModal" />`,
      components: {
        GooglePlaces,
      },
      data() {
        return {
          openModal: null,
        };
      },
      methods: {
        setActiveModal(modal) {
          this.openModal = modal;
          googleMap.openModal = modal;
        },
      },
    });
  }

  // Experience - Hero
  if (document.querySelector("#hero")) {
    var iframe = document.querySelector("#hero iframe");
    var player = new Player(iframe);
    let overlay = document.querySelector(".video-modal-overlay");

    document.querySelectorAll(".video-cta").forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        console.log("Video modal");

        overlay.classList.toggle("active");
        player.play();
      });
    });

    overlay.addEventListener("click", (e) => {
      e.preventDefault();

      player.pause();
      overlay.classList.toggle("active");
    });

    document.onkeydown = (e) => {
      e = e || window.event;

      if (e.key == "Escape" && overlay.classList.contains("active")) {
        player.pause();
        overlay.classList.toggle("active");
      }
    };
  }

  // Leasing - Form
  if (document.querySelector("#form")) {
    form = new Vue({
      el: "#form",
      template: "<leasingForm />",
      components: {
        leasingForm,
      },
    });
  }

  if (document.querySelector("#main-navigation")) {
    anime({
      targets: document.querySelectorAll("#main-navigation .tab"),
      delay: (el, i) => {
        return i * 300;
      },
      duration: 500,
      easing: "easeOutSine",
      width: "100%",
    });

    const mobileNav = document.querySelector("#mobile-nav");
    const hamburger = mobileNav.querySelector(".header #hamburger");
    const close = mobileNav.querySelector(".header #close");

    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );
    mobileNav.querySelector("nav").style.height = `${vh - 80}px`;

    const headroom = new Headroom(mobileNav);

    headroom.init({
      tolerance: 10,
    });

    swup.on("contentReplaced", () => {
      console.log("Content Replaced");
      document.body.classList.remove("noscroll");
      mobileNav.classList.remove("active");
    });

    hamburger.addEventListener("click", (e) => {
      document.body.classList.add("noscroll");
      mobileNav.classList.add("active");
    });

    close.addEventListener("click", (e) => {
      document.body.classList.remove("noscroll");
      mobileNav.classList.remove("active");
    });
  }

  // Building and Neighborhood - Sub-nav
  if (document.querySelector(".tabbed-menu")) {
    document
      .querySelector(".tabbed-menu .active")
      .scrollIntoView({ behavior: "smooth", block: "end" });
  }

  // Footer
  if (document.querySelector("footer")) {
    // Footer
    const footer = document.querySelector("footer");
    const trigger = document.querySelector("#trigger");

    const callback = (entries, observer) => {
      if (entries[0].isIntersecting) {
        footer.classList.add("active");
      } else {
        footer.classList.remove("active");
      }
    };

    if (!!window.IntersectionObserver && trigger) {
      const observer = new IntersectionObserver(callback);
      observer.observe(trigger);
    }
  }

  // Leasing Google Map
  if (document.querySelector("#map .google-map")) {
    simpleGoogleMap = new Vue({
      el: "#map .google-map",
      template: "<simpleMap />",
      components: {
        simpleMap,
      },
    });
  }

  // Building - Directions - TabList
  if (document.querySelector(".directions.building")) {
    swup.on("willReplaceContent", () => {
      directions.$destroy();
    });

    directions = new Vue({
      name: "directions",
      el: ".directions.building .sidebar .tablist",
      template: "<TabList />",
      components: {
        TabList,
      },
    });
  }

  // Building - Public Transportation - TabList
  if (document.querySelector(".public-transportation.building")) {
    swup.on("willReplaceContent", () => {
      pt.$destroy();
    });

    pt = new Vue({
      name: "public-transportation",
      el: ".public-transportation.building .sidebar .tablist",
      template: "<TabList />",
      components: {
        TabList,
      },
    });
  }

  // Building - Stacking - TabList
  if (document.querySelector(".stacking.building")) {
    swup.on("willReplaceContent", () => {
      stacking.$destroy();
      stackingImage.$destroy();
    });

    stacking = new Vue({
      name: "stacking",
      el: ".stacking.building .sidebar .tablist",
      template:
        '<TabList :modal="this.activeModal" v-on:modalClosed="clearModal()" v-on:modalOpened="openModal($event)" />',
      data() {
        return {
          activeModal: null,
        };
      },
      components: {
        TabList,
      },
      methods: {
        clearModal() {
          this.activeModal = null;
          stackingImage.openModal = null;
        },
        openModal(modalNum) {
          stackingImage.openModal = modalNum;
          this.activeModal = modalNum;
        },
      },
    });

    stackingImage = new Vue({
      name: "stacking-image",
      el: "#stacking-plan",
      data() {
        return {
          openModal: stacking.openModal,
        };
      },
      methods: {
        setActiveModal(modalNum) {
          stacking.openModal(modalNum);
        },
      },
    });
  }

  // Building
  if (document.querySelector(".building")) {
    swup.on("willReplaceContent", () => {
      buildingMenu.$destroy();
    });

    buildingMenu = new Vue({
      el: "#tabbed",
      components: {
        tabbed: TabbedMenu,
      },
    });
  }
}
